
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReportRefundReasonSumBillDialog extends Serenity.EntityDialog<ReportRefundReasonSumBillRow, any> {
        protected getFormKey() { return ReportRefundReasonSumBillForm.formKey; }
        protected getIdProperty() { return ReportRefundReasonSumBillRow.idProperty; }
        protected getLocalTextPrefix() { return ReportRefundReasonSumBillRow.localTextPrefix; }
        protected getNameProperty() { return ReportRefundReasonSumBillRow.nameProperty; }
        protected getService() { return ReportRefundReasonSumBillService.baseUrl; }
        protected getDeletePermission() { return ReportRefundReasonSumBillRow.deletePermission; }
        protected getInsertPermission() { return ReportRefundReasonSumBillRow.insertPermission; }
        protected getUpdatePermission() { return ReportRefundReasonSumBillRow.updatePermission; }

        protected form = new ReportRefundReasonSumBillForm(this.idPrefix);
        
        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
               buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            return buttons;


        }

    }
}